export default "__VITE_ASSET__60B2UztP__"